import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Nicht angemeldet.");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function authHeadersAdmin() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Sign in required.");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * @param {string} url
 */
export async function submitSuggestedSourceUrl(url) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/source-submissions/submit`, {
    method: "POST",
    headers,
    body: JSON.stringify({ url }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Speichern fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {{ status?: string }} [params]
 */
export async function fetchSourceSubmissionAdminQueue(params = {}) {
  const headers = await authHeadersAdmin();
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", String(params.status));
  const q = qs.toString();
  const res = await fetch(
    `${API_BASE}/api/source-submissions/admin${q ? `?${q}` : ""}`,
    { method: "GET", headers },
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Failed to load queue (${res.status}).`);
  }
  const list = data.items;
  if (!Array.isArray(list)) {
    throw new Error("Invalid server response.");
  }
  return list;
}

/**
 * @param {{ sourceUrl: string }} payload
 */
export async function previewSourceSubmissionCard(payload) {
  const headers = await authHeadersAdmin();
  const res = await fetch(
    `${API_BASE}/api/source-submissions/admin/preview-card`,
    {
      method: "POST",
      headers,
      body: JSON.stringify({ sourceUrl: payload.sourceUrl || "" }),
    }
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Preview failed (${res.status}).`);
  }
  return data;
}

/**
 * @param {{
 *   submissionId: string,
 *   action: "approve" | "reject",
 *   finalUrl?: string,
 *   reason?: string,
 *   createLlmCardOnApprove?: boolean,
 *   cardDraft?: object,
 * }} payload
 */
export async function reviewSourceSubmissionAdmin(payload) {
  const headers = await authHeadersAdmin();
  const body = {
    submissionId: payload.submissionId,
    action: payload.action,
    finalUrl: payload.finalUrl || "",
    reason: payload.reason || "",
  };
  if (typeof payload.createLlmCardOnApprove === "boolean") {
    body.createLlmCardOnApprove = payload.createLlmCardOnApprove;
  }
  if (payload.cardDraft && typeof payload.cardDraft === "object") {
    body.cardDraft = payload.cardDraft;
  }
  const res = await fetch(`${API_BASE}/api/source-submissions/admin/review`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Action failed (${res.status}).`);
  }
  return data;
}
